import dayjs from "dayjs";
import { useParams } from "react-router";
import ReactToPrint from "react-to-print";
import React, { useContext, useRef, useState, useEffect } from "react";
import { FiPrinter } from "react-icons/fi";
import { IoCloudDownloadOutline } from "react-icons/io5";
import {
  TableCell,
  TableHeader,
  Table,
  TableContainer,
  WindmillContext,
} from "@windmill/react-ui";
import { PDFDownloadLink } from "@react-pdf/renderer";

import useAsync from "hooks/useAsync";
import QuoteStatus from "components/table/QuoteStatus";

import Quote from "components/invoice/Quote";
import Loading from "components/preloader/Loading";
import logoDark from "assets/img/logo/sim_new.jpg";
import logoLight from "assets/img/logo/sim_new_white.jpg";
import PageTitle from "components/Typography/PageTitle";
import InvoiceForDownload from "components/invoice/InvoiceForDownload";
import SettingServices from "services/SettingServices";
import QuoteServices from "services/QuoteServices";
import { useTranslation } from "react-i18next";

const QuoteManagementDetails = () => {
  const { t } = useTranslation();
  const { mode } = useContext(WindmillContext);
  const { id } = useParams();
  const printRef = useRef();
  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const { loading } = useAsync(() => QuoteServices.getAdminQuoteById(id));
  const { data: globalSetting } = useAsync(SettingServices.getGlobalSetting);

  const currency = globalSetting?.default_currency || "$";

  const getAdminQuoteById = async () => {
    try {
      const res = await QuoteServices.getAdminQuoteById(id);
      // Mettez à jour le state avec les départements récupérés depuis l'API
      setData(res.data);
    } catch (err) {
      console.log(err ? err?.response?.data?.message : err?.message);
    }
  }

  const getAdminQuoteRowsById = async () => {
    try {
      const res = await QuoteServices.getAdminQuoteRowsById(id);
      // Mettez à jour le state avec les départements récupérés depuis l'API
      setRows(res.data);
    } catch (err) {
      console.log(err ? err?.response?.data?.message : err?.message);
    }
  }

  useEffect(() => {
    getAdminQuoteById();
    getAdminQuoteRowsById();
  }, []);
  return (
    <>
      <PageTitle> {t("Quote")} </PageTitle>

      <div
        ref={printRef}
        className="bg-white dark:bg-gray-800 mb-4 p-6 lg:p-8 rounded-xl shadow-sm overflow-hidden"
      >
        {!loading && (
          <div className="">
            <div className="flex lg:flex-row md:flex-row flex-col lg:items-center justify-between pb-4 border-b border-gray-50 dark:border-gray-700 dark:text-gray-300">
              <h1 className="font-bold font-serif text-xl uppercase">
                {t("Quote")}

               
                  <p className=" hide-on-print text-xs mt-1 text-gray-500">
                    {t("Status")}
                    <span className="pl-2 font-medium text-xs capitalize">
                      {" "}
                      <QuoteStatus status={data.status} t={t} />
                    </span>
                  </p>

              
              </h1>
              <div className="lg:text-right text-left">
                <h2 className="lg:flex lg:justify-end text-lg font-serif font-semibold mt-4 lg:mt-0 lg:ml-0 md:mt-0">
                  {mode === "dark" ? (
                    <img src={logoLight} alt="dashtar" width="110" />
                  ) : (
                    <img src={logoDark} alt="dashtar" width="110" />
                  )}
                </h2>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
                  {globalSetting?.address}
                </p>
              </div>
            </div>
            <div className="flex lg:flex-row md:flex-row flex-col justify-between pt-4">
              <div className="mb-3 md:mb-0 lg:mb-0 flex flex-col">
                <span className="font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("Quote Date")}
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 block">
                  {data.quoteDate !== undefined && (
                    <span>{dayjs(data?.quoteDate).format("MMMM D, YYYY")}</span>
                  )}
                </span>

                <span className="font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("Expiration Date")}
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 block">
                  {data.expirationDate !== undefined && (
                    <span>{dayjs(data?.expirationDate).format("MMMM D, YYYY")}</span>
                  )}
                </span>
              </div>
              <div className="mb-3 md:mb-0 lg:mb-0 flex flex-col">
                <span className="font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("Quote No")}
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 block">
                  #{t('Quote')}-{data?.id}
                </span>
              </div>
              <div className="flex flex-col lg:text-right text-left">
                <span className="font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("Quote To")}
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 block">
                  {data.user ?

                    (<>

                      {data?.user?.name} <br />
                      {data?.user?.email}{" "}<br />
                      <span className="ml-2">{data?.user?.phone}</span><br />
                      <span className="ml-2">{data?.user?.tax_number}</span>
                      {/* <br />
                  {data?.user?.address?.substring(0, 30)} */}
                      <br />
                      {data?.user?.city && data?.user?.country && data?.user?.zipCode &&
                        (<>{data?.user?.city}, {data?.user?.country},{" "}
                          {data?.user?.zip}</>)}

                    </>) : (
                      <>
                        {data?.quote?.first_name}{" "}{data?.quote?.last_name} <br />
                        {data?.quote?.email}{" "}<br />
                        <span className="ml-2">{data?.quote?.phone}</span><br />
                        <span className="ml-2">{data?.quote?.tax_number}</span>
                        {/* <br />
                  {data?.user?.address?.substring(0, 30)} */}
                        <br />
                        {data?.quote?.city && data?.quote?.country && data?.quote?.zipCode &&
                          (<>{data?.quote?.city}, {data?.quote?.country},{" "}
                            {data?.quote?.zip}</>)}

                      </>
                    )}

                </span>
              </div>
            </div>
          </div>
        )}
        <div>
          {loading ? (
            <Loading loading={loading} />
          ) : (
            <TableContainer className="my-8">
              <Table>
                <TableHeader>
                  <tr>
                    <TableCell>{t("Sr")}</TableCell>
                    <TableCell>{t("Description")}</TableCell>
                    <TableCell className="text-center">{t("Quantity")}</TableCell>
                    <TableCell className="text-center">{t("Unit ")}</TableCell>
                    <TableCell className="text-center">{t("Item Price HT")}</TableCell>
                    <TableCell className="text-right">{t("Amount HT")}</TableCell>
                  </tr>
                </TableHeader>
                <Quote
                  data={rows}
                  currency={currency}
                  globalSetting={globalSetting}
                />
              </Table>
            </TableContainer>
          )}
        </div>

        {!loading && (

          <div className="border rounded-xl border-gray-100 p-8 py-6 bg-gray-50 dark:bg-gray-900 dark:border-gray-800">
            <div className="flex justify-end">

              <div className="grid grid-cols-1 gap-4">
                <div className="mb-0 flex flex-col text-right">
                  <span className="font-bold text-sm uppercase text-gray-600 dark:text-gray-500">
                    {t("Total")} {t("HT")}: {'   '}

                    <span className=" text-sm text-gray-500 dark:text-gray-400 font-semibold ">
                      {parseFloat(data.totalAmount).toFixed(2)} {t("dt")}
                    </span>

                  </span>

                </div>
                <div className="mb-0 flex flex-col text-right">
                  <span className="font-bold text-sm uppercase text-gray-600 dark:text-gray-500">
                    {t("InvoiceDicount")}:: {'   '}<span className="text-sm text-gray-500 dark:text-gray-400 font-semibold">
                      {parseFloat(data.discount).toFixed(2)}%
                    </span>
                  </span>

                </div>
                <div className="mb-0 flex flex-col text-right">
                  <span className="font-bold text-sm uppercase text-gray-600 dark:text-gray-500">

                    {t("Tax Rate")}: {'   '}<span className="text-sm text-gray-500 dark:text-gray-400 font-semibold">

                      {parseFloat(data.taxRate).toFixed(2)}%
                    </span>
                  </span>

                </div>

                {/* <div className="mb-0 flex flex-col text-right">
                  <span className="font-bold text-sm uppercase text-gray-600 dark:text-gray-500">
                    {t("Adjustments HT")}: {'   '} <span className="text-sm text-gray-500 dark:text-gray-400 font-semibold" >
                      {parseFloat(data.adjustments).toFixed(2)} {t("dt")}
                    </span>
                  </span>

                </div> */}
                <div className="flex flex-col text-right">
                  <span className="font-bold text-sm uppercase text-gray-600 dark:text-gray-500">
                    {t("InvoiceTotalAmount")} {t("TTC")}: {'   '}<span className="text-xl font-bold text-red-500 dark:text-orange-500" >
                      {parseFloat(data.total).toFixed(2)} {t("dt")}
                    </span>
                  </span>

                </div>
              </div>
            </div>
          </div>
        )}


        <br />

        {!loading && data.quoteDescription && (
          <div className="grid grid-cols-full gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
            <div className="col-span-8 sm:col-span-4">

              <p className="text-md mt-1 text-gray-500" style={{whiteSpace: 'pre-wrap'}}>{data.quoteDescription}</p>



            </div>
          </div>)}
      </div>
      {!loading && (
        <div className="mb-4 mt-3 flex justify-between">
          <PDFDownloadLink
            document={
              <InvoiceForDownload
                t={t}
                rows={rows}
                data={data}
                currency={currency}
                globalSetting={globalSetting}
              />
            }
            fileName={`Quote-${id}.pdf`}
          >
            {({ blob, url, loading, error }) =>
              loading ? (
                "Loading..***."
              ) : (
                <button className="flex items-center text-sm leading-5 transition-colors duration-150 font-medium focus:outline-none px-5 py-2 rounded-md text-white bg-orange-500 border border-transparent active:bg-orange-600 hover:bg-orange-600 focus:ring focus:ring-purple-300 w-auto cursor-pointer">
                  {t('Download Quote')}
                  <span className="ml-2 text-base">
                    <IoCloudDownloadOutline />
                  </span>
                </button>
              )
            }
          </PDFDownloadLink>

          <ReactToPrint
            trigger={() => (
              <button className="flex items-center text-sm leading-5 transition-colors duration-150 font-medium focus:outline-none px-5 py-2 rounded-md text-white bg-orange-500 border border-transparent active:bg-orange-600 hover:bg-orange-600 focus:ring focus:ring-purple-300 w-auto">
                {t("Print Quote")}
                <span className="ml-2">
                  <FiPrinter />
                </span>
              </button>
            )}
            content={() => printRef.current}
            documentTitle={`Quote-${id}`}
          />
        </div>
      )}
    </>
  );
};

export default QuoteManagementDetails;
